import React from 'react';
import SocialLinks from '../SocialLinks';
import './Footer.css';

const Footer = props => {
  return (
    <footer>
      <div className="wrapper">
        <h3>LOOKING FORWARD TO MEET YOU</h3>
        <p>© {new Date().getFullYear()} Robin Kreuger.</p>
        <SocialLinks />
      </div>
    </footer>
  );
};

export default Footer;
